<script lang="ts" setup>
import Zone from '@/components/cards/Zone.vue'

const props = defineProps<{
  event: components['schemas']['Event']
  title: string
}>()

const { data: objectList, status } = useApi<components['schemas']['Zone'][]>(
  `/ticketing/events/${props.event.slug}/zones/`,
  {
    query: {
      type: 'virtual',
    },
  }
)
</script>

<template>
  <div>
    <h3>{{ title }}</h3>

    <DataView
      :loading="status === 'pending'"
      :value="objectList ?? []"
      dataKey="id"
      lazy
      loader
    >
      <template #list="{ items }: { items: components['schemas']['Zone'][] }">
        <div class="gap-5 grid grid-cols-2">
          <Zone
            v-for="item in items"
            :key="item.id"
            :event="props.event"
            :zone="item"
          />
        </div>
      </template>
    </DataView>
  </div>
</template>
